export default "__VITE_ASSET__8bqKe_WP__"